<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/waXjZD/tc-custom/9781429914086.jpg?1728726041453" alt="This image is the cover for the book Draco Tavern"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Draco Tavern
      </h1>
      <p class="bookDescription body article font2">
        <b>The #1 <i>New York Times</i>–bestselling author presents twenty-six tales and vignettes from this interplanetary gathering place: “A must for Nivenites” (<i>Booklist</i>).</b><br/><br/>When a tremendous spacecraft took orbit around the Earth’s moon and began sending smaller landers down toward the North Pole, the newly arrived visitors quickly set up a permanent spaceport at Mount Forel in Siberia. Their presence attracted many, and a few people grew conspicuously rich from secrets they learned from talking to the aliens. One of these men, Rick Schumann, opened the Draco Tavern, a public house catering to all species of visiting aliens.<br/><br/>In “The Subject Is Closed”, a priest visits the tavern and goes one-on-one with a chirpsithra alien on the subject of God and life after death. Rick Schumann is invited to hunt with five folk aliens in “Table Manners”, but he begins to wonder if he will be the hunted. And in the never-before-published tale “Losing Mars”, a group of Martians arrive at the Tavern only to find that humans have mostly forgotten about their neighboring planet.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Larry Niven
      </h2>
      
      <p class="authorDescription body article"><P><B>Larry Niven </B>is the multiple Hugo and Nebula Award-winning author of the Ringworld series, along with many other science fiction masterpieces. His<I> Beowulf's Children</I>, co-authored with Jerry Pournelle and Steven Barnes was a<I> New York Times</I> bestseller. He lives in Chatsworth, California.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?cd657490